export default "__VITE_ASSET__AMFMXcpi__"